<template>
  <v-container fluid>
    <PageHeaderSlot>
      <template slot="top-right-slot" v-if="canCreate">
        <FormButton text="createCampus" isAdd class="ml-2" :to="{ name: 'CreateSchool' }" />
      </template>
    </PageHeaderSlot>

    <Datatable
      :isLoading="tableLoading"
      :tableHeaders="tableHeaders"
      :tableData="tableData"
      :page.sync="tableFilter.page"
      :pageLimit.sync="tableFilter.limit"
      :itemTotal="tableItemTotal"
      @options-update="getSchoolData()"
      actionViewRouteLink="SchoolDetails"
    >
      <template v-slot:[`item.website_and_app`]="{ item }">
        <div
          class="table-radio mx-auto"
          :class="{
            selected: selectedWebsiteSetting === item.id,
            disabled: !canEdit,
          }"
          v-ripple
          @click="onWebsiteCenterChanged(item.id)"
        ></div>
      </template>
      <template v-slot:[`header.website_and_app`]>
        <div class="text-left">
          {{ $t('applyToWebsite') }}
          <small class="d-block">{{ $t('settingDes') }}</small>
        </div>
      </template>
    </Datatable>

    <FormButton
      v-if="tableData.length > 0 && canEdit && !gDisableSettingByCenter"
      class="mt-4"
      :disabled="tableLoading"
      @click="save()"
    />
  </v-container>
</template>

<script>
import Datatable from '@/components/Datatable.vue'

export default {
  name: 'SchoolList',
  components: {
    Datatable,
  },
  computed: {
    tableHeaders() {
      const vm = this
      let headers = [
        { value: 'tutor_school_name', text: vm.$t('campusName'), width: 250 },
        { value: 'address', text: vm.$t('address') },
      ]
      if (!this.gDisableSettingByCenter) {
        headers.push({ value: 'website_and_app', text: `${vm.$t('applyToWebsite')}`, align: 'end', width: 200 })
      }
      if (this.$validate.allowAction('SchoolDetails', this.userType)) {
        headers.push({ value: 'actionView', text: '', align: 'end', width: 120 })
      }
      return headers
    },
    // permission & setting
    canCreate() {
      return this.$validate.allowAction('CreateSchool', this.userType)
    },
    canEdit() {
      if (this.isAppMode(['T46']) && this.userType === 'admin') return false
      return this.$validate.allowAction('SchoolDetails', this.userType)
    },
  },
  data: vm => ({
    userType: vm.gfGetUserType(),
    selectedWebsiteSetting: null,
    initSelectedWebsiteSetting: null,

    tableLoading: false,
    tableData: [],
    tableItemTotal: 0,
    tableFilter: {
      page: 1,
      limit: 10,
    },
  }),
  methods: {
    async getSchoolData(regenUrl = true) {
      if (regenUrl === true) {
        this._regenerateURL()
      }
      this.tableLoading = true
      try {
        let payload = {
          filter_limit: this.tableFilter.limit,
          filter_page: this.tableFilter.page - 1,
        }

        const { data, total } = await this.$Fetcher.GetSchools(payload)
        this.tableData = data.map(el => {
          return {
            id: el.id,
            tutor_school_name: el.name,
            address: el.address,
          }
        })

        this.tableItemTotal = total
      } catch (err) {
        this.tableData = []
        if (this.tableFilter.page === 1) {
          this.tableItemTotal = 0
        }
      } finally {
        this.tableLoading = false
      }
    },

    _getQuery() {
      this.tableFilter.page = 1
      this.tableFilter.limit = 10
      const query = this.gfGetTableQuery({
        page: 'int',
        limit: 'int',
      })
      for (const key in this.tableFilter) {
        if (this.$validate.DataValid(query[key])) {
          this.$set(this.tableFilter, key, query[key])
        }
      }
    },
    _regenerateURL() {
      let q = {
        page: this.tableFilter.limit !== 10 || this.tableFilter.page !== 1 ? this.tableFilter.page : null,
        limit: this.tableFilter.limit !== 10 || this.tableFilter.page !== 1 ? this.tableFilter.limit : null,
      }
      const newQuery = this.$common.diffQuery(q, this.$route.query)
      if (newQuery) this.$router.replace({ query: newQuery })
    },

    // ====== 設定應用到網頁
    async _getSelectedWebsiteCenter() {
      try {
        const { data } = await this.$Fetcher.GetSchools({
          filter_item: [{ key: 'website_and_app', value: '' }],
          filter_page: 0,
          filter_limit: 1,
        })
        this.selectedWebsiteSetting = data[0].id
        this.initSelectedWebsiteSetting = data[0].id
      } catch (err) {
        if (err !== 'abort') {
          this._getFirstSchool()
        }
      }
    },
    async _getFirstSchool() {
      try {
        const { data } = await this.$Fetcher.GetSchools({
          sort_dir: 'asc',
          order_by: 'id',
          filter_page: 0,
          filter_limit: 1,
        })
        this.selectedWebsiteSetting = data[0].id
      } catch {}
    },
    async save() {
      if (this.$store.getters.isLoading) {
        this.$store.dispatch('toggleSnack', { message: 'processing' })
        return
      }
      if (this.tableData.length < 1) return

      if (this.initSelectedWebsiteSetting !== this.selectedWebsiteSetting) {
        this.$store.dispatch('setLoading', true)
        try {
          // 將原本個個變做false
          await this._updateInitSelected()

          // update new selected
          await this.$Fetcher.UpdateSchool(this.selectedWebsiteSetting, {
            website_and_app: true,
          })
          this.$store.dispatch('setDataIsUpdated', false)
          this.$store.dispatch('toggleSnack', {
            message: 'message.saveSuccess',
            type: 'success',
          })
          this.initSelectedWebsiteSetting = this.selectedWebsiteSetting
          this.getSchoolData(false)
        } catch (err) {
          this.showAlert({
            title: 'message.saveFail',
            message: err,
            isError: true,
          })
        } finally {
          this.$store.dispatch('setLoading', false)
        }
      }
    },
    async _updateInitSelected() {
      return new Promise(async (resolve, reject) => {
        if (this.initSelectedWebsiteSetting !== null) {
          try {
            // 將原本個個變做false
            await this.$Fetcher.UpdateSchool(this.initSelectedWebsiteSetting, {
              website_and_app: false,
            })
            resolve(true)
          } catch (err) {
            reject(err)
          }
        } else {
          resolve(true)
        }
      })
    },
    onWebsiteCenterChanged(value) {
      if (this.selectedWebsiteSetting === value) return
      this.selectedWebsiteSetting = value
      this.$store.dispatch('setDataIsUpdated', true)
    },

    async handleSiteLoaded() {
      this.$common.log('>>>>>>>>>>>>>>>>>>>>>>>>>>>> handleSiteLoaded: SchoolList')
      this.userType = this.gfGetUserType()
      this._getQuery()
      this.$store.dispatch('toggleLoadingPage', false)

      if (!this.gDisableSettingByCenter) {
        await this._getSelectedWebsiteCenter()
      }
      await this.getSchoolData(false)
    },
  },
  destroyed() {
    window.removeEventListener('onSiteLoaded', this.handleSiteLoaded)
  },
  mounted() {
    this.tableLoading = true
    this.$store.dispatch('toggleLoadingPage', true)
    window.addEventListener('onSiteLoaded', this.handleSiteLoaded)
  },
  // ------ navigation guard ------
  beforeRouteLeave(to, from, next) {
    if (this.$store.getters.isLoading) {
      this.$store.dispatch('toggleSnack', { message: 'processing' })
      next(false)
    } else if (this.$store.getters.dataIsUpdated) {
      this.$store.dispatch('showLeaveAlert', { toLink: { name: to.name } })
      next(false)
    } else {
      this.$XHR.abort()
      next()
    }
  },
}
</script>

<style lang="scss" scoped>
.table-radio {
  border-radius: 100% !important;
  position: relative;
  cursor: pointer;
  width: 20px !important;
  height: 20px !important;
  min-width: 20px !important;
  min-height: 20px !important;
  border: 2px solid var(--v-colorGrey-base);
}

.table-radio.selected {
  border-color: var(--v-primary-base);
  pointer-events: none;
}

.table-radio.disabled {
  pointer-events: none;
}

.table-radio.selected::after {
  content: '';
  position: absolute;
  width: 60%;
  height: 60%;
  background-color: var(--v-primary-base);
  border-radius: 100%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  pointer-events: none;
}

.table-radio::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  pointer-events: none;
  width: 30px !important;
  height: 30px !important;
  min-width: 30px !important;
  min-height: 30px !important;
  border-radius: 100%;
  background-color: var(--v-colorBlack-base);
  opacity: 0.2;
  display: none;
}

.table-radio:hover::before {
  display: block;
}
</style>
